import { HttpContextToken } from '@angular/common/http';

export const DRY_RUN = new HttpContextToken<boolean>(() => false);
